import { HsIndexedGeometry } from './indexed-geometry.class';

export class HsSpriteGeometry extends HsIndexedGeometry {}
